<mobile-page-part>

	<div class="info-content">
		{{util.date.formatUTC(currentUTC, 'DOW MMM D, YYYY', 'No Time', 'en-US')}}
	</div>

	<departments-list [departments]="departments()"></departments-list>

</mobile-page-part>